import axios from "axios";

const instance = axios.create({
  baseURL: "https://tiktok-backend-tarun.herokuapp.com/",
});

export default instance;
